module.exports = __webpack_public_path__ + "static/media/poll-check.c9a2d876.svg";